/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as strings from '@touchplan/strings';

@Component({
	selector: 'multi-wrapper',
	templateUrl: './multi-wrapper.component.html',
	styles: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiWrapperComponent {
	public focus$ = new BehaviorSubject<boolean>(false);
	@Input() public metadataValue: 'multiple' | 'cleared';
	@Input() public multipleValuesLabel = strings.GENERAL_MULTIPLE_VALUES;
	@Input() public keyToClear: string;
	@Input() public disableClear = false;
	@Output() public onClear = new EventEmitter();

	constructor() {}

	public clearInput() {
		// this.ticketEditService.clearInput(this.keyToClear);
		this.onClear.emit();
	}
}
